import { U21Object } from 'app/modules/dataMapping/types';
import { U21_OBJECT_TYPE_TO_COLOR } from 'app/modules/pullBasedDataFiles/constants';
import { U21Chip } from 'app/shared/u21-ui/components';
import styled from 'styled-components';

export const ObjectChip = styled(U21Chip)<{
  $objectType?: `${U21Object}`;
}>`
  ${(props) => {
    let paletteColor = 'grey';
    if (props.$objectType && U21_OBJECT_TYPE_TO_COLOR[props.$objectType]) {
      paletteColor = U21_OBJECT_TYPE_TO_COLOR[props.$objectType];
    }

    const { main, contrastText } = props.theme.palette.colors[paletteColor];
    return `
      background-color: ${main};
      color: ${contrastText};
    `;
  }};
`;
